import numberWithLabelChoices from './numberWithLabelChoices'

const percentChoices = (values) => numberWithLabelChoices(values, '%')

export default percentChoices



// WEBPACK FOOTER //
// ./src/utils/forms/percentChoices.js